import { CalendarClock, MapPin } from "lucide-react";
import {
  formatPickupAddress,
  formatPickupScheduledAt,
  type OrderPickupDetails,
} from "@gaole/shared";

export function PickupScheduleCallout({
  details,
  readyForPickup = false,
  compact = false,
}: {
  details: OrderPickupDetails;
  readyForPickup?: boolean;
  compact?: boolean;
}) {
  const when = formatPickupScheduledAt(details.scheduledAt);

  if (compact) {
    return (
      <div className="mt-2 flex items-start gap-2.5 rounded-xl border border-brand-pink/30 bg-brand-pink/[0.12] px-3 py-2.5">
        <CalendarClock size={16} className="mt-0.5 shrink-0 text-brand-pink" strokeWidth={2} />
        <div className="min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-brand-pink/90">
            Pickup
          </p>
          <p className="font-display text-sm font-bold leading-snug text-white">{when}</p>
          <p className="mt-0.5 truncate text-[11px] text-white/55">{details.name}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`rounded-2xl border p-4 ${
        readyForPickup
          ? "border-emerald-400/40 bg-emerald-500/10"
          : "border-brand-pink/40 bg-gradient-to-br from-brand-pink/20 via-brand-pink/10 to-brand-blue/10"
      }`}
    >
      {readyForPickup ? (
        <p className="mb-2 text-xs font-semibold text-emerald-300">Your order is ready for pickup</p>
      ) : null}
      <div className="flex gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${
            readyForPickup ? "bg-emerald-500/20 text-emerald-300" : "bg-brand-pink/20 text-brand-pink"
          }`}
        >
          <CalendarClock size={22} strokeWidth={2} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">
            Pickup date &amp; time
          </p>
          <p className="font-display text-lg font-bold leading-tight text-white">{when}</p>
          <p className="mt-2 flex items-center gap-1.5 text-sm font-semibold text-white/90">
            <MapPin size={14} className="shrink-0 text-brand-pink" />
            <span className="truncate">{details.name}</span>
          </p>
          <p className="mt-0.5 text-xs leading-relaxed text-white/60">{formatPickupAddress(details)}</p>
        </div>
      </div>
    </div>
  );
}
